import React from "react";
import MerchantPaymentMethods from "modules/merchantPaymentMethods";

const MerchantPaymentMethodsPage = () => {
  return <MerchantPaymentMethods />;
};

export default MerchantPaymentMethodsPage;
